"use client";

import { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { store, persistor } from "../store/store";
import { PersistGate } from "redux-persist/integration/react";
import setupInterceptors from "../api/intercepter";
import { useApp } from "../shared/AppProvider/AppProvider";
import { commonActions } from "../features/common/redux/slice";

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const storeRef = useRef(store);
  const { notify } = useApp();

  useEffect(() => {
    setupInterceptors(store, notify);
    setTimeout(() => {
      storeRef.current?.dispatch(commonActions.stopLoading())
      storeRef.current?.dispatch(commonActions.startPageLoading())
    }, 100)
  }, []);

  return (
    <Provider store={storeRef.current}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}
